module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('md-card', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5rem"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('h2', [_vm._v("E-Mail Content")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "event"
    }
  }, [_vm._v("Event Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "event",
      "id": "event"
    },
    model: {
      value: (_vm.emailModal.event),
      callback: function($$v) {
        _vm.$set(_vm.emailModal, "event", $$v)
      },
      expression: "emailModal.event"
    }
  }), _vm._v(" "), (!_vm.emailModal.event) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSend.event))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "11"
    }
  }, [_c('label', [_vm._v("Email Content")]), _vm._v(" "), _c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "300px !important",
      "background": "#fff",
      "display": "inline-block"
    },
    model: {
      value: (_vm.emailModal.description),
      callback: function($$v) {
        _vm.$set(_vm.emailModal, "description", $$v)
      },
      expression: "emailModal.description"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": "11"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "id": "sendLoaderMain"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v(_vm._s(_vm.emailModal.contentId == '' ? 'Add' : 'Edit'))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "sendLoader"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), (_vm.emailBody.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.emailBody.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header text-center"
  }, [_c('h2', [_vm._v("Mail Content Details")])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": "truckDetail2"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Event")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.emailBody), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.editMail(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.event))])])
  }))])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aaa7f32","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/mailMaster/addMailContent.vue
// module id = 2532
// module chunks = 0